import React from 'react';
import './ui-parts.css';

export default function ChoiceList({ props: p, actions, onAction, partId, disabled, dir }) {
  const items = p.items || [];
  const title = p.title || '';
  const list = Array.isArray(items) ? items : [];
  const selectAction = (actions || []).find((a) => a.id === 'choice.select') || { mode: 'patch' };

  return (
    <div className="ui-choice-list" dir={dir}>
      {title && <div className="ui-part-title">{title}</div>}
      <div className="ui-choice-grid">
        {list.map((item, i) => {
          const id = item.id ?? item.key ?? i;
          const label = item.label ?? item.name ?? item.title ?? String(id);
          const selected = item.selected;
          return (
            <button
              key={id}
              type="button"
              className={`ui-choice-btn${selected ? ' selected' : ''}`}
              disabled={disabled}
              onClick={() =>
                onAction?.({
                  actionId: 'choice.select',
                  mode: selectAction.mode,
                  payload: {
                    value: id,
                    label,
                    field: p.field,
                    route_pattern_id: item.stops ? id : undefined,
                    item,
                  },
                  partId,
                })
              }
            >
              {label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
